/**
 * 数值输出动画
 */
import fvAnimation from "./fvAnimation"
export default class fvOutput extends fvAnimation {
    constructor(shape){
        super(shape,"fvOutput");
        this.isShowInvalid = shape.isShowInvalid;
        this.textInvalid = shape.textInvalid;
        this.expression.replace(/\s+/g,"");
        
        // var str=this.expression.substring(9,this.expression.length);
        // this.expression = "__dbTags."+str.toUpperCase()
        // this.sizeFunction = new AsyncFunction("return " + this.expression);
        this.tag = this.expression;
        this.sizeFunction = new AsyncFunction("return " + this.expression);
    }
    getReal(tagsName){
        //添加$字段来适应对以数字开头的点
        tagsName = tagsName.substr(0,tagsName.length-3);
        tagsName = "$"+tagsName.split('.').join('.$')
        if(typeof tagsName == "string"){
            var names = tagsName.split(".");
            var result;
            if(window.__dbTags){
                result = window.__dbTags[names[0]];
            }
            for(var i = 1;i < names.length;i++){
                if(result === undefined){
                    break;
                }
                result = result[names[i]];
            }
            if(result != undefined){
                return result;
            }else{
                var pArr = tagsName.split(".");
                var p = pArr[pArr.length - 1];
                if(this.system.$.tagConfig[p]){
                    tagsName = tagsName.replace("." + p ,"");
                }
                //
                this.alreadyRegTags.push(tagsName);
                this.system.$.dbCom.declareTags([{firstValue:0,name:tagsName}]);
                this.system.$.dbCom.sendMessage({
                    head : "registryTag",
                    dbVar : [tagsName]
                },(result)=>{});
                return true;
            }
        }else{
            console.warn("点名称错误，只能是字符串类型");
            return false;
        }
    }
    async run(canvas,value){
        // if(this.tag.indexOf("__systemMidVar")>-1){
        //     //以字符串为中间变量时调用
        //     var data = await this.executionScript(this.sizeFunction);
        //     console.log(data)
        //     //var size = this.getReal(data).PV;
        // }else{
        //     var size = await this.executionScript(this.sizeFunction);
        // }
        // if(size == "__defaule" || size == undefined){
        //     size = "...";
        // }
        var size = await this.executionScript(this.sizeFunction);
        if(this.isShowInvalid){//每个字体的无效值
            if(size == -9999 || size == "__defaule" || size == undefined){
                size = this.textInvalid;
            }else if(size === ""){
                size = '...';
            }
        }else{
            if(size == -9999 || size == "__defaule" || size == undefined){
                if(this.shape.system.$.jsonSysRootConfig.textInvalid != ""){
                    size = this.shape.system.$.jsonSysRootConfig.textInvalid;
                }
            }else if(size === ""){
                size = '...';
            }
        }
        this.shape.innerText = size;
    }

}


// WEBPACK FOOTER //
// ./src/js/canvas/animation/fvOutput.js